import React from 'react';
import { Booking } from '../types/booking.types';

interface BookingMetadataProps {
  booking: Booking;
}

const BookingMetadata: React.FC<BookingMetadataProps> = ({ booking }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-3 mb-6 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm border border-gray-200">
      <div>
        <span className="text-gray-500 block">Slot Date</span>
        <span className="font-semibold text-gray-800">{booking.slot_date}</span>
      </div>
      <div>
        <span className="text-gray-500 block">Payment Type</span>
        <span className="font-semibold text-gray-800">{booking.payment_type?.replace('_', ' ').toUpperCase()}</span>
      </div>
      <div>
        <span className="text-gray-500 block">Payment Status</span>
        <span className={`font-semibold ${booking.payment_status === 'completed' ? 'text-green-600' : 'text-orange-600'}`}>
          {booking.payment_status?.toUpperCase()}
        </span>
      </div>
      <div>
        <span className="text-gray-500 block">Created At</span>
        <span className="font-semibold text-gray-800">{new Date(booking.created_at).toLocaleDateString()}</span>
      </div>
    </div>
  );
};

export default BookingMetadata;
